import React from 'react';
import { Badge, InlineStack, SkeletonBodyText, Text } from '@shopify/polaris';
import { IBundleApp } from './config';
import { StyledPlanCard, StyledPlanGrid, StyledPlanLabel } from './styled';

interface IPlanGridProps {
  app: IBundleApp;
  selectedPlanId: string;
  onChange: (planId: string) => void;
  isLoading?: boolean;
}

const PlanGrid = ({ app, selectedPlanId, onChange, isLoading }: IPlanGridProps) => (
  <StyledPlanGrid>
    {app.plans.map((plan) => {
      const active = selectedPlanId === plan.id;
      const isCurPlan = app.isCurrent && app.currentPlanId === plan.id;
      const inputId = `plan-${app.id}-${plan.id}`;

      return (
        <StyledPlanLabel key={plan.id} htmlFor={inputId}>
          <StyledPlanCard $active={active}>
            <InlineStack align="space-between" blockAlign="start">
              <input
                type="radio"
                id={inputId}
                name={`plan-group-${app.id}`}
                checked={active}
                onChange={() => onChange(plan.id)}
                disabled={isLoading}
                style={{ width: 13, height: 13, accentColor: '#008060' }}
              />
              {isCurPlan && <Badge tone="info">Current</Badge>}
            </InlineStack>
            <Text variant="bodySm" fontWeight="semibold" as="span">
              {plan.name}
            </Text>
            <Text variant="bodySm" tone="subdued" as="span">
              {plan.quota}
            </Text>
            {isLoading ? (
              <div style={{ paddingBlockStart: 4 }}>
                <SkeletonBodyText lines={1} />
              </div>
            ) : (
              <Text variant="bodyMd" fontWeight="semibold" as="p">
                {plan.price === 0 ? 'Free' : `$${plan.price.toFixed(2)}/mo`}
              </Text>
            )}
          </StyledPlanCard>
        </StyledPlanLabel>
      );
    })}
  </StyledPlanGrid>
);

export default PlanGrid;
